import type { ReactNode } from "react";

const URL_PATTERN = /(https?:\/\/[^\s<]+)/g;
// Pontuação de fim de frase colada no fim da URL (ex.: "confira: https://x.com.") não deveria
// entrar no link — só corta no final do trecho casado, nunca no meio (preserva query string).
const TRAILING_PUNCTUATION = /[.,;:!?)'"\]]+$/;

/** Quebra um texto em partes simples + links clicáveis — URLs http(s) viram <a target="_blank">. */
export function linkifyText(text: string): ReactNode[] {
  if (!text) return [];
  return text.split(URL_PATTERN).flatMap((part, i) => {
    if (i % 2 === 0) return part ? [part] : [];
    const trailingMatch = part.match(TRAILING_PUNCTUATION);
    const trailing = trailingMatch ? trailingMatch[0] : "";
    const url = trailing ? part.slice(0, -trailing.length) : part;
    return [
      <a
        key={i}
        href={url}
        target="_blank"
        rel="noreferrer"
        className="underline break-all"
        onClick={(e) => e.stopPropagation()}
      >
        {url}
      </a>,
      trailing,
    ].filter(Boolean);
  });
}
